import { useCallback, useContext, useEffect, useRef, useState } from "react";
import StoryList from "./story-list/story-list";
import StoryView from "./story-view/story-view";
import StoryVoteManager from "./story-vote/story-vote-manager";
import Waitable from "../../common/waitable/waitable";
import { GameStatus } from "../../../types/game-status";
import { useAppSelector } from "../../../redux/store";
import { GameContext } from "../../../contexts";
import { selectPlayerStatus, selectLoading, selectError } from "../../../redux/selectors";

const ReadingTime = () => {
  const { submit } = useContext(GameContext);

  // Use narrow selectors to avoid rerenders on unrelated state changes
  const playerStatus = useAppSelector(selectPlayerStatus);
  const loading = useAppSelector(selectLoading);
  const error = useAppSelector(selectError);

  const [page, setPage] = useState(0);

  const story = useRef<number | undefined>(undefined);

  const submitted = useRef(false);

  useEffect(() => {
    if (
      page === 1 &&
      !loading &&
      submitted.current &&
      !error
    ) {
      submitted.current = false;
      setPage(0);
    }
  }, [error, loading, page]);

  useEffect(() => {
    if (
      playerStatus === GameStatus.GameStatusResults ||
      playerStatus === GameStatus.GameStatusPostReading
    ) {
      setPage(2);
    }
  }, [playerStatus]);

  function handleVote(voteId: number, storyId: number) {
    submitted.current = true;
    submit({
      code: "story/vote",
      body: {
        vote: {
          id: voteId,
          story_id: storyId,
        },
      },
    });
  }

  let comp;
  switch (page) {
    case 0:
      comp = (
        <StoryList
          onVote={() => setPage(2)}
          onClick={(s) => {
            // setStory(s)
            story.current = s;
            setPage(1);
          }}
        />
      );
      break;
    case 1:
      comp = (
        <StoryView
          storyIndex={story.current as number}
          onBack={() => setPage(0)}
        />
      );
      break;
    case 2:
      // comp = <StoryVote award={Gamers.awards ? Gamers.awards[0] : undefined} onVote={handleVote} onBack={() => setPage(0)}/>
      comp = (
        <Waitable
          playerActionHandler={submit}
          waitingFor={[GameStatus.GameStatusPostReading]}
          waitHeader={"waiting for voters.."}
          audienceOverride={true}
        >
          <StoryVoteManager
            loading={loading}
            onVote={handleVote}
            onBack={() => setPage(0)}
          />
        </Waitable>
      );
      break;
  }

  return <>{comp}</>;
  // return <Waitable playerActionHandler={onAction} waitingFor={PlayerStatus.PlayerStatusStoryReacting}
  //                  waitHeader={"waiting for voters.."}>{comp}</Waitable>
};
export default ReadingTime;
